import { render, staticRenderFns } from "./teamAssessment.vue?vue&type=template&id=d2c6fd9a&scoped=true&"
import script from "./teamAssessment.vue?vue&type=script&lang=js&"
export * from "./teamAssessment.vue?vue&type=script&lang=js&"
import style0 from "./teamAssessment.vue?vue&type=style&index=0&id=d2c6fd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c6fd9a",
  null
  
)

export default component.exports